/**
 * Google Analytics 4 loader. No-op if REACT_APP_GA4_MEASUREMENT_ID is empty.
 * - Injects the gtag.js script tag once (idempotent).
 * - Sends a page_view on every route change (call `sendPageview()`).
 */
const GA_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

let initialized = false;

export function initAnalytics() {
  if (initialized || !GA_ID) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // send_page_view: false → we send page views manually on route changes
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
  initialized = true;
}

export function sendPageview(path) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path || window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", name, params);
}
